'use client'
import React from "react"
import type { FC } from 'react'
import Script from 'next/script';
import config from '@/config';

const QT: FC = () => {
  
  // 动态生成脚本内容
  const scriptContent = `
    function initQT(w, d, s, q) {
      w[q] = w[q] || []
      const f = d.getElementsByTagName(s)[0]; const j = d.createElement(s)
      j.async = true
      j.id = 'beacon-aplus'
      j.src = 'https://d.alicdn.com/alilog/mlog/aplus/203704088.js?'
      f.parentNode.insertBefore(j, f)
    }
    initQT(window, document, 'script', 'aplus_queue');
    aplus_queue.push({ action: 'aplus.setMetaInfo', arguments: ['appKey', '${config.QT_API_KEY}'] });
    aplus_queue.push({ action: 'aplus.setMetaInfo', arguments: ['aplus-rhost-v', 'log-api.mercedes-benz.com.cn'] });
    aplus_queue.push({ action: 'aplus.setMetaInfo', arguments: ['aplus-disable-apv', true]});
  `;


  return (
    <>
      {
        config.QT_API_KEY && (
          <Script id="setup-qt" strategy='afterInteractive'>
            {scriptContent}
          </Script>
        )
      }
    </>
  )
}

export default React.memo(QT)